import { render, staticRenderFns } from "./interProRegisterEntry.vue?vue&type=template&id=535b8735&scoped=true"
import script from "./interProRegisterEntry.vue?vue&type=script&lang=js"
export * from "./interProRegisterEntry.vue?vue&type=script&lang=js"
import style0 from "./interProRegisterEntry.vue?vue&type=style&index=0&id=535b8735&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b8735",
  null
  
)

export default component.exports